module.exports = __webpack_public_path__ + "fonts/RenaultLife-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Light.ttf
// module id = 361
// module chunks = 0